import weightLimits from './data/vehicle-weight-limits';
import lengthLimits from './data/vehicle-length-limits';
import trim from './trim';

function getVehicleWeightOrLengthLimitById(id) {
  const trimmedId = trim(id);
  const limits = {
    ...weightLimits,
    ...lengthLimits,
  };
  return limits[trimmedId];
}

export default getVehicleWeightOrLengthLimitById;
